export enum DictType {
  COUNTRY,
  PROVINCE,
  CITY,
  SCHOOL,
  FACULTY,
  DIRECTION,
  SPECIALITY,
  SCHOOL_DEGREE,
  CERTIFICATE,
  POSITION,
  COMPETENCE,
  EMPLOYER,
  TRAINING,
  EMPLOYER_BLIND,
  EDUCATION_PROFILE,
  CV_TARGET,
  ECONOMY_SECTOR,
  DOMAIN
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/dict-types.enum.ts